var publicPath = __webpack_public_path__;
                    var symbolUrl = 'sprites.d7297429b712f0db2eb964354e7b2856.svg#bX';
                    var viewUrl = 'sprites.d7297429b712f0db2eb964354e7b2856.svg#view-bX';

                    

                    module.exports = {
                        url: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '0 0 94 13',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };